import { Heading } from "@planningcenter/doxy-web"
import React from "react"
import { Loading } from "./Loading"
import { StripePaymentElement } from "./stripe"
import { useDonationFormContext } from "../hooks/useDonationFormContext"
import { Frequency, StripePaymentMethod } from "../types"

type PaymentMethodSelectorProps = {
  frequency: Frequency
  savePaymentMethodChecked: boolean
  stripePaymentMethod?: StripePaymentMethod
}

// TODO: (if possible) mark this as the focused pane when SPE has been
// interacted with

export function PaymentMethodSelector({
  frequency,
  savePaymentMethodChecked,
  stripePaymentMethod,
}: PaymentMethodSelectorProps) {
  const { dispatch } = useDonationFormContext()

  const showSavePaymentMethodCheckbox =
    frequency.type === "once" &&
    !stripePaymentMethod?.id &&
    stripePaymentMethod?.type === "card"

  const handleSavePaymentMethodCheckboxChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    dispatch({
      type: "SET_SAVE_PAYMENT_METHOD_CHECKED",
      savePaymentMethodChecked: event.target.checked,
    })
  }

  return (
    <div>
      <Heading level={3} text="Payment method" />
      <React.Suspense fallback={<Loading />}>
        <div className="mt-1">
          <StripePaymentElement />
        </div>
      </React.Suspense>
      {showSavePaymentMethodCheckbox && (
        <div className="mt-2">
          <input
            className="checkbox"
            id="savePaymentMethodCheckbox"
            checked={savePaymentMethodChecked}
            onChange={handleSavePaymentMethodCheckboxChange}
            type="checkbox"
          />
          <label htmlFor="savePaymentMethodCheckbox" className="checkbox-label">
            Save this payment method
          </label>
        </div>
      )}
    </div>
  )
}
